import { CONTACT } from "@/data";

export function buildWhatsAppUrl(message, phone = CONTACT.whatsapp) {
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(message, phone) {
  window.open(buildWhatsAppUrl(message, phone), "_blank", "noopener,noreferrer");
}
